import { render, staticRenderFns } from "./A7PainelParameter.vue?vue&type=template&id=ff976aa2&scoped=true&"
import script from "./A7PainelParameter.vue?vue&type=script&lang=js&"
export * from "./A7PainelParameter.vue?vue&type=script&lang=js&"
import style0 from "./A7PainelParameter.vue?vue&type=style&index=0&id=ff976aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff976aa2",
  null
  
)

export default component.exports